export const ModalCloseButtonStyles = {
  container:
    'absolute top-2 right-2 bg-gray70 p-2 inline-flex justify-center items-center cursor-pointer rounded-md'
}
